export default {
    title: 'Partenaires',
    subtitle: 'Les partenaires que vos vidéos ONISEP peuvent citer. Un partenaire est retiré plutôt que supprimé : les vidéos qui le citent déjà le conservent.',
    add: 'Ajouter un partenaire',
    addFirst: 'Ajoutez votre premier partenaire',
    addTitle: 'Ajouter un partenaire',
    editTitle: 'Modifier le partenaire',
    edit: 'Modifier',
    retire: 'Retirer',
    restore: 'Rétablir',
    retired: 'Retiré',
    retireTitle: 'Retirer le partenaire',
    retireMessage: 'Retirer le partenaire « {name} » ? Il ne sera plus proposé pour les nouvelles vidéos. Les vidéos qui le citent déjà le conservent, et vous pourrez le rétablir à tout moment.',
    internal: 'Interne',
    filters: {
        all: 'Tous les partenaires',
        internal: 'Partenaires internes',
        external: 'Partenaires externes',
    },
    showRetired: 'Afficher les partenaires retirés',
    created: 'Partenaire ajouté.',
    saved: 'Partenaire enregistré.',
    retiredToast: '« {name} » retiré.',
    restored: '« {name} » rétabli.',
    search: 'Rechercher des partenaires...',
    empty: 'Aucun partenaire pour le moment.',
    noResults: 'Aucun partenaire ne correspond à votre recherche.',
    refine: 'Seuls les {count} premiers partenaires sont affichés : affinez votre recherche.',
    table: {
        logo: 'Logo',
        name: 'Nom',
        type: 'Type',
        url: 'URL',
        actions: 'Actions',
    },
    types: {
        institutional: 'Institutionnel',
        business: 'Monde économique',
        media: 'Média',
    },
    form: {
        name: 'Nom du partenaire',
        type: 'Type',
        url: 'URL du site web',
        urlHint: 'Une adresse commençant par http:// ou https://',
        logo: 'Logo',
        logoHint: 'Le logo affiché avec ce partenaire, y compris dans le catalogue de l\'ONISEP',
        isInternal: 'Partenaire interne',
    },
    errors: {
        load: 'Les partenaires n\'ont pas pu être chargés.',
        nameTaken: 'Un partenaire porte déjà ce nom — peut-être un partenaire retiré, que vous pouvez rétablir.',
        invalid: 'Vérifiez le nom, le site web (http:// ou https://) et le logo — qui doit être téléversé à nouveau au-delà d\'un jour.',
        forbidden: 'Vous n\'êtes pas autorisé à gérer les partenaires.',
        unavailable: 'Les partenaires ne sont pas disponibles pour cette organisation.',
        generic: 'Le partenaire n\'a pas pu être enregistré.',
    },
}
